
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"9","cy":"9","r":"8.5","fill":"#fff","stroke":"#DADFEB"}}),_c('path',{attrs:{"d":"M8.297 10.348h1.2c0-1.572 2.123-1.704 2.123-3.708 0-1.332-1.115-2.136-2.843-2.136-1.404 0-2.448.492-3.108 1.344l.876.624c.48-.612 1.176-.948 2.148-.948 1.08 0 1.716.528 1.716 1.296 0 1.38-2.112 1.644-2.112 3.528zm.612 2.724a.758.758 0 00.768-.768.75.75 0 00-.768-.768.754.754 0 00-.78.768c0 .42.324.768.78.768z","fill":"#000"}})])
          )
        }
      }
    